"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PropTypes = require('prop-types');

var React = require('react');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var TextLabel = require('../textLabel');

var CollapseArrow = require('./collapseArrow.svg.js');

var collapseLabel = /*#__PURE__*/function (_React$Component) {
  _inherits(collapseLabel, _React$Component);

  var _super = _createSuper(collapseLabel);

  function collapseLabel(props) {
    var _this;

    _classCallCheck(this, collapseLabel);

    _this = _super.call(this, props);
    _this.state = {
      isOpen: false,
      childHasHover: false
    };

    _this.onToggle = function () {
      if (!_this.props.disabled) {
        if (_this.props.customToggle) {
          _this.props.customToggle();

          _this.callOnToggleIfNeeded(!_this.props.isOpen);
        } else {
          _this.setState(function (prevState) {
            return _objectSpread(_objectSpread({}, prevState), {}, {
              isOpen: !prevState.isOpen
            });
          }, function () {
            return _this.callOnToggleIfNeeded(_this.state.isOpen);
          });
        }
      }
    };

    _this.callOnToggleIfNeeded = function (isOpen) {
      if (_this.props.onToggle) {
        _this.props.onToggle(isOpen);
      }
    };

    _this.isChildHover = function () {
      return _this.state.childHasHover;
    };

    _this.handleOnMouseEnter = function () {
      return !_this.state.childHasHover && _this.setState(_objectSpread(_objectSpread({}, _this.state), {}, {
        childHasHover: true
      }));
    };

    _this.handleOnMouseLeave = function () {
      return _this.state.childHasHover && _this.setState(_objectSpread(_objectSpread({}, _this.state), {}, {
        childHasHover: false
      }));
    };

    _this.getIconState = function () {
      return _this.isOpen() ? 'open' : 'closed';
    };

    _this.isOpen = function () {
      return _this.props.customToggle ? _this.props.isOpen : _this.state.isOpen;
    };

    return _this;
  }

  _createClass(collapseLabel, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        "data-aid": "collapse-label-root",
        "data-hook": this.props.dataHook,
        className: this.props.getClassName('control-collapse-label') + ' ' + (this.props.disabled ? 'disabled' : '') + ' ' + (this.isChildHover() ? 'child-has-hover' : '')
      }, /*#__PURE__*/React.createElement("div", {
        "data-aid": "collapse-label-switch",
        className: "collapse-label-switch",
        onClick: this.onToggle,
        "aria-checked": this.isOpen()
      }, /*#__PURE__*/React.createElement(TextLabel, {
        automationId: "collapse-text-label",
        value: this.props.translateIfNeeded(this.props.label),
        type: "T15",
        disabled: this.props.disabled,
        shouldTranslate: this.props.shouldTranslate
      }), /*#__PURE__*/React.createElement("div", {
        "data-aid": "switch-open",
        className: 'switch-open ' + this.getIconState()
      }, /*#__PURE__*/React.createElement(CollapseArrow, null))), this.isOpen() ? /*#__PURE__*/React.createElement("div", {
        "data-aid": "collapsed-content-container",
        className: "collapsed-content-container",
        key: "collapsed-content-container",
        onMouseEnter: this.handleOnMouseEnter,
        onMouseLeave: this.handleOnMouseLeave
      }, this.props.children) : null);
    }
  }]);

  return collapseLabel;
}(React.Component);

collapseLabel.displayName = displayNames.COLLAPSE_LABEL;
collapseLabel.propTypes = {
  /** Label text to display */
  label: PropTypes.string.isRequired,

  /** Callback after toggle */
  onToggle: PropTypes.func,

  /** Callback function to be used in controlled mode */
  customToggle: PropTypes.func,

  /** Disables toggling */
  disabled: PropTypes.bool,

  /** Controlled state of collapse (only with `customToggle`) */
  isOpen: PropTypes.bool,

  /** Hook for testing purposes  */
  dataHook: PropTypes.string
};
collapseLabel.defaultProps = {
  disabled: false
};
module.exports = compose(collapseLabel);